"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
var uuid = require("uuid");
function LS() {
    if (typeof localStorage !== 'undefined') {
        return {
            all: function () {
                return localStorage;
            },
            getItem: function (key) {
                return localStorage.getItem(key);
            },
            setItem: function (key, value) {
                return localStorage.setItem(key, value);
            },
            removeItem: function (key) {
                return localStorage.removeItem(key);
            },
        };
    }
    var _storage = {};
    return {
        all: function () {
            return JSON.parse(JSON.stringify(_storage));
        },
        getItem: function (key) {
            if (_storage[key]) {
                return '' + _storage[key];
            }
            else {
                return undefined;
            }
        },
        setItem: function (key, value) {
            _storage[key] = '' + value;
        },
        removeItem: function (key) {
            delete _storage[key];
        },
    };
}
function LocalStorage(config) {
    var _this = this;
    var ls = LS();
    var subscription = [];
    return {
        get: function (key) {
            var value = ls.getItem(config.prfx + "_" + key);
            if (value) {
                try {
                    return JSON.parse(value);
                }
                catch (error) {
                    return value;
                }
            }
            return undefined;
        },
        set: function (key, value) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _i, i, e;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        try {
                            if (typeof value === 'object') {
                                ls.setItem(config.prfx + "_" + key, JSON.stringify(value));
                            }
                            else {
                                ls.setItem(config.prfx + "_" + key, value);
                            }
                        }
                        catch (error) {
                            console.error(error);
                            return [2, false];
                        }
                        _a = [];
                        for (_b in subscription)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 4];
                        i = _a[_i];
                        e = subscription[i];
                        if (!(e.key === config.prfx + "_" + key)) return [3, 3];
                        return [4, e.handler(value, 'set')];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4: return [2, true];
                }
            });
        }); },
        remove: function (key) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _i, i, e;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        try {
                            ls.removeItem(config.prfx + "_" + key);
                        }
                        catch (error) {
                            console.error(error);
                            return [2, false];
                        }
                        _a = [];
                        for (_b in subscription)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 4];
                        i = _a[_i];
                        e = subscription[i];
                        if (!(e.key === config.prfx + "_" + key)) return [3, 3];
                        return [4, e.handler(undefined, 'remove')];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4: return [2, true];
                }
            });
        }); },
        subscribe: function (key, handler) { return __awaiter(_this, void 0, void 0, function () {
            var id;
            var _this = this;
            return __generator(this, function (_a) {
                id = uuid.v4();
                subscription.push({
                    id: id,
                    key: config.prfx + "_" + key,
                    handler: handler,
                });
                return [2, function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            subscription = subscription.filter(function (e) { return e.id !== id; });
                            return [2];
                        });
                    }); }];
            });
        }); },
        clear: function () { return __awaiter(_this, void 0, void 0, function () {
            var l, _a, _b, _i, key, _c, _d, _e, i, e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        l = JSON.parse(JSON.stringify(ls.all()));
                        _a = [];
                        for (_b in l)
                            _a.push(_b);
                        _i = 0;
                        _f.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 6];
                        key = _a[_i];
                        if (!key.startsWith(config.prfx)) return [3, 5];
                        ls.removeItem(key);
                        _c = [];
                        for (_d in subscription)
                            _c.push(_d);
                        _e = 0;
                        _f.label = 2;
                    case 2:
                        if (!(_e < _c.length)) return [3, 5];
                        i = _c[_e];
                        e = subscription[i];
                        if (!(e.key === key)) return [3, 4];
                        return [4, e.handler(undefined, 'remove')];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _e++;
                        return [3, 2];
                    case 5:
                        _i++;
                        return [3, 1];
                    case 6: return [2];
                }
            });
        }); },
    };
}
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=local-storage.js.map